import { createFileRoute } from "@tanstack/react-router";
import ApiKeyPage from "src/components/app/ApiKeyPage/ApiKeyPage";
import { DeferredLoaderData } from "src/lib/LoaderData";
import { projectLoader } from "src/lib/ScopedLoaders";
import { getApiKeysPageData } from "src/server/functions/Portal";

export const Route = createFileRoute("/_authed/portal/proj_{$projectKey}/api-keys")({
  loader: projectLoader((projectId) => getApiKeysPageData({ data: projectId })),
  component: ApiKeysPage,
});

function ApiKeysPage() {
  return (
    <DeferredLoaderData result={Route.useLoaderData()}>
      {(data) => <ApiKeyPage initialPage={data?.initialPage} />}
    </DeferredLoaderData>
  );
}
